<div class="container-fluid">
  <div class="card">
    <div class="card-body">
      <div class="card col-md-12">
        <div class="card-header"><h2 class="orange-border">Upload</h2></div>
        <div class="card-body">
          <div class="row form-group ">
            <div class="col-md-8 card-text">
              <h4> The CSV file is expected to be uploaded in the following format:</h4>
              <h4><i>{{ getFileFormatDescription() }}</i></h4>
            </div>
            <div class="form-group col-md-4">
              <button (click)="downloadSampleUploadFile()"
                class="navy-btn col-md-4 center"
                id="downloadFile"
                type="button">
                Download Sample File
              </button>
            </div>
          </div>

          <div class="row form-group">
            <div class="col-md-4 message-credits">
              <p><strong>Emails Remaining: {{ messageCounters?.emailCounter }}</strong></p>
              <p><strong>SMSs Remaining: {{ messageCounters?.smsCounter }}</strong></p>
            </div>
          </div>
          <!--Upload File Input Group -->
          <div class="row form-group">
            <label class="input-group col-md-12" for="uploadGroup">Payments File:</label>
            <div class="input-group col-md-12" id="uploadGroup">
              <div class="custom-file col-md-7 col-sm-12">
                <input #fileInput
                  (change)="previewAndValidateFile($event)"
                  (click)="clearFileInput()"
                                       accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                                    application/vnd.ms-excel"
                  class="custom-file-input"
                  data-toggle="tooltip"
                  id="uploadFile"
                  type="file"/> <label class="custom-file-label"
                for="uploadFile">{{ getFileName() }}</label>
              </div>
              <div class="input-group-append col-md-5 col-sm-6">
                <button #sendButton
                  (click)="submit()"
                  [disabled]="isSendDisabled"
                  class="navy-btn btn-margin-top spacing-mid col-sm-3">
                <i class="fa fa-send fa-lg"></i> &nbsp; Send
              </button>
              <button #clearButton
                (click)="clearAll()"
                [disabled]="!isAccountListPopulated() || isLoading()"
                class="navy-btn btn-margin-top spacing-mid col-sm-3"
                                        pTooltip="This will erase the preview field and you will have
                                        to resubmit the file.">
                <i class="fa fa-remove fa-lg"></i> &nbsp; Clear
              </button>
            </div>
          </div>
        </div>

        <!--Billing Type Input -->
        <div [hidden]="!isAccountListPopulated() || hasUploadErrors() || isLoading()"
          class="row form-group">
          <div class="col-md-6">
            <label for="batchNameField"> Batch Name: </label> <input #batchNameField
            (change)="focusBatchName()"
            [(ngModel)]="batchName"
            class="custom-text-input"
            id="batchNameField"
            maxlength="30"
            placeholder="Enter Batch Name"
            type="text"/>
        </div>
        @if (!isMultiPremiumEnabled) {
          <div class="col-md-6">
            <label for="allowPartialPayments">Allow Partial Payment: </label>
                                <i class="pi pi-question-circle tooltip-icon" pTooltip="If enabled, customers will be allowed to pay any amount between the minimum
                             allowed (R{{(minimumRequestToPayAmount/100).toFixed(2)}}) and the total."></i>
            <div class="form-inline">
              <p-toggleswitch [(ngModel)]="allowPartialPayments"
                [ngModelOptions]="{standalone: true}"
              id="allowPartialPayments"></p-toggleswitch>
              <h4 class="margin-toggle">{{ isAllowPartialPayments() }}</h4>
            </div>
          </div>
        }
        <div class="row field-checkbox col-md-12 m-1 p-1 ml-3">
          <p-checkbox (onChange)="updateSendEmail()"
            [(ngModel)]="generateInvoice"
            [binary]="true"
            id="billingType"
          inputId="billingType"></p-checkbox>
          <label class="p-checkbox-label margin-bottom-zero" for="billingType"> Auto-generate invoice
          (An email will be sent with the invoice) </label>
          <i class="pi pi-question-circle tooltip-icon"
          pTooltip="If enabled, every request to pay transaction notification email sent out to customers will have an auto-generated invoice attached."></i>
        </div>
        <div class="row field-checkbox col-md-12 m-1 p-1 ml-3">
          <div style="margin-right: 10px">
            <p-checkbox (onChange)="updateGenerateInvoice()"
              [(ngModel)]="sendEmail"
              [binary]="true"
              id="sendEmail"
            inputId="sendEmail"></p-checkbox>
            <label class="p-checkbox-label margin-bottom-zero" for="sendEmail"> Send an email for
            each request to pay </label>
          </div>
          @if (hasInsufficientEmailCredits()) {
            <p class="text-danger">
              You have insufficient email credits to perform this action. Please top up your balance
            or opt to send without email notifications. </p>
          }
        </div>
        <div class="row field-checkbox col-md-12 m-1 p-1 ml-3">
          <div style="margin-right: 10px">
            <p-checkbox [(ngModel)]="sendSMS"
              [binary]="true"
              id="sendSMS"
            inputId="sendSMS"></p-checkbox>
            <label class="p-checkbox-label margin-bottom-zero" for="sendSMS"> Send an SMS for each
            request to pay </label>
          </div>
          @if (hasInsufficientMerchantSmsCredits()) {
            <p class="text-danger">
              You have insufficient SMS credits to perform this action. Please top up your balance or
            opt to send without SMS notifications. </p>
          }
          @if (!hasInsufficientMerchantSmsCredits() && hasInsufficientSystemSmsCredits()) {
            <p
              class="text-danger">
              SMS is unavailable at this time, please try again later or contact support using Get
            Help in the menu </p>
          }
        </div>
      </div>
      <div class="row col-md-5">
        <button (click)="downloadValidationFile()"
          [hidden]="!(hasUploadErrors() || hasUploadWarnings())"
          class="navy-btn col-md-4"
          pTooltip="This will download a file containing a list of all valid & invalid accounts."
          style="float: right">
          <i class="fa fa-download fa-lg"></i> &nbsp; Download Validation File
        </button>
      </div>
      <br>
        <!-- Upload file errors view -->
                    <div [hidden]="accountErrorPreviewList == null ||
                         accountErrorPreviewList.length == 0" class="row" id="failuresView">
          <div class="card-header"><h2 class="orange-border">Errors</h2></div>
          <div class="form-group col-md-12">
            <table class="table table-hover table-responsive-md">
              <thead>
                <tr>
                  <th scope="col">Line Number</th>
                  <th scope="col">Line</th>
                  <th scope="col">Error Message</th>
                </tr>
              </thead>
              <tbody class="table-hover text-nowrap">
                @for (uploadError of accountErrorPreviewList; track uploadError) {
                  <tr>
                    <td [pTooltip]="!isWindowWidthSmall() ? uploadError.lineNumber.toString() : null">
                      {{ uploadError.lineNumber }}
                    </td>
                    <td [pTooltip]="!isWindowWidthSmall() ? uploadError.line : null">
                      {{ uploadError.line }}
                    </td>
                    <td [pTooltip]="!isWindowWidthSmall() ? uploadError.errorMessage : null"
                      class="text-danger">
                      {{ uploadError.errorMessage }}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
            @if (!!uploadErrorList && uploadErrorList?.length > 10) {
              <div class="valid-upload-note">
                <p> Previewing 10 of {{ uploadErrorList.length }} error records. Please download the
                validation file to view additional records </p>
              </div>
            }
          </div>
        </div>

        <!-- Upload file warnings view -->
                    <div [hidden]="accountWarningPreviewList == null ||
                         accountWarningPreviewList.length == 0" class="row" id="warningsView">
          <div class="card-header"><h2 class="orange-border">Alerts</h2></div>
          <div class="form-group col-md-12">
            <table class="table table-hover table-responsive-md">
              <thead>
                <tr>
                  <th scope="col">Line Number</th>
                  <th scope="col">Line</th>
                  <th scope="col">Alert Message</th>
                </tr>
              </thead>
              <tbody class="table-hover text-nowrap">
                @for (uploadWarning of accountWarningPreviewList; track uploadWarning) {
                  <tr>
                    <td [pTooltip]="!isWindowWidthSmall() ? uploadWarning.lineNumber.toString() : null">
                      {{ uploadWarning.lineNumber }}
                    </td>
                    <td [pTooltip]="!isWindowWidthSmall() ? uploadWarning.line : null">
                      {{ uploadWarning.line }}
                    </td>
                    <td [pTooltip]="!isWindowWidthSmall() ? uploadWarning.warningMessage : null"
                      class="text-danger">
                      {{ uploadWarning.warningMessage }}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
            @if (!!uploadWarningList && uploadWarningList?.length > 10) {
              <div
                class="valid-upload-note">
                <p> Previewing 10 of {{ uploadWarningList.length }} alert records. Please download the
                validation file to view additional records </p>
              </div>
            }
          </div>
        </div>

        <!-- Upload file preview -->
                    <div [hidden]="accountPreviewList == null ||
                         accountPreviewList.length == 0" class="row" id="successView">
          <div class="card-header">
            <h2 class="orange-border">Preview</h2>
          </div>
          <div class="form-group col-md-12">
            <table class="table table-hover table-responsive-md">
              <thead>
                <tr>
                  <th scope="col">Reference Number</th>
                  @if (useCustomAccountNumbers) {
                    <th scope="col">Account Number</th>
                  }
                  <th scope="col">Client Name</th>
                  <th scope="col">Description</th>
                  <th scope="col">Amount</th>
                  <th scope="col">Email</th>
                  <th scope="col">Mobile</th>
                  <th scope="col">Expiry Period</th>
                  @if (isMultiPremiumEnabled) {
                    <th scope="col">Multi Premium Option</th>
                  }
                  <th scope="col">Business Display Name</th>
                </tr>
              </thead>
              <tbody class="table-hover text-nowrap">
                @for (accountCreate of accountPreviewList; track accountCreate) {
                  <tr>
                    <td [pTooltip]="!isWindowWidthSmall() ? accountCreate.referenceNumber : null">
                      {{ accountCreate.referenceNumber }}
                    </td>
                    @if (useCustomAccountNumbers) {
                      <td [pTooltip]="!isWindowWidthSmall() ? accountCreate.accountNumber : null">
                        {{ accountCreate.accountNumber }}
                      </td>
                    }
                    <td [pTooltip]="!isWindowWidthSmall() ? accountCreate.customer : null">
                      {{ accountCreate.customer }}
                    </td>
                    <td [pTooltip]="!isWindowWidthSmall() ? accountCreate.description : null">
                      {{ accountCreate.description }}
                    </td>
                    <td [pTooltip]="!isWindowWidthSmall() ? (accountCreate.amount | toMajor | currency: 'R ') : null">
                      {{ accountCreate.amount | toMajor | currency:'R ' }}
                    </td>
                    <td [pTooltip]="!isWindowWidthSmall() ? accountCreate.customerEmail : null">
                      {{ accountCreate.customerEmail }}
                    </td>
                    <td [pTooltip]="!isWindowWidthSmall() ? accountCreate.customerMobileNumber : null">
                      {{ accountCreate.customerMobileNumber }}
                    </td>
                    <td [pTooltip]="!isWindowWidthSmall() ? accountCreate.dateTimeExpire : null">
                      {{ getDifferenceInDays(accountCreate?.dateTimeExpire) }} days
                    </td>
                    @if (isMultiPremiumEnabled) {
                      <td [pTooltip]="!isWindowWidthSmall() ? accountCreate.multiPremium : null">
                        {{ accountCreate.multiPremium }}
                      </td>
                    }
                    <td [pTooltip]="!isWindowWidthSmall() ? accountCreate.merchantDisplayName : null">
                      {{ accountCreate?.merchantDisplayName }}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
            @if (!!accountCreateList && accountCreateList?.length > 10) {
              <div
                class="valid-upload-note">
                <p> Previewing 10 of {{ accountCreateList.length }} valid records. All other records are
                also valid </p>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
<ngx-ui-loader></ngx-ui-loader>